import React, { useState } from "react";
import { Link } from "react-router-dom";
import HeaderAlertsIcon from "./HeaderAlertsIcon";
import HeaderAlertsTitle from "./HeaderAlertsTitle";
import HeaderAlertsEmpty from "./HeaderAlertsEmpty";
import RlNavigationDropdownItem from "../navigation/components/RlNavigationDropdownItem";
import AlertDescription from "../../alerts/components/AlertDescription";
import useLatestUnresolvedAlerts from "../../alerts/hooks/useLatestUnresolvedAlerts";
import { PAGE_PATH } from "../../../path";

const HeaderAlerts = ({
  linksReloadDocument = false
}: {
  linksReloadDocument?: boolean;
}) => {
  const {
    alerts,
    count = 0,
    shouldConfigureAlerts = false
  } = useLatestUnresolvedAlerts();
  const [closeDropdown, setCloseDropdown] = useState(false);

  const handleAlertDropdownClose = () => setCloseDropdown(true);
  const linkText = count > 5 ? "See All Alerts" : "Go to Alerts Page";

  return (
    <RlNavigationDropdownItem
      title={<HeaderAlertsIcon count={count} />}
      id="header-alerts"
      parentCloseControl={{ close: closeDropdown, setClose: setCloseDropdown }}
    >
      <HeaderAlertsTitle count={count} />
      {alerts.map(alert => (
        <div
          key={alert.uuid}
          className="header-alerts__list-item"
          data-testid="header_alerts_list_item"
        >
          <AlertDescription
            data={alert}
            linksReloadDocument={linksReloadDocument}
            onLinkClick={handleAlertDropdownClose}
          />
        </div>
      ))}
      {!alerts.length && (
        <HeaderAlertsEmpty
          shouldConfigure={shouldConfigureAlerts}
          onLinkClick={handleAlertDropdownClose}
          reloadDocument={linksReloadDocument}
        />
      )}
      <div className="header-alerts__list-item text-center">
        <Link
          to={PAGE_PATH.ALERTS}
          className="main-nav__submenu-item-link"
          reloadDocument={linksReloadDocument}
          onClick={handleAlertDropdownClose}
        >
          {linkText}
        </Link>
      </div>
    </RlNavigationDropdownItem>
  );
};

export default HeaderAlerts;
